"use client";

import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import BuyCourse from "@/components/cli/BuyCourse/BuyCourse";
import WaitCourse from "@/components/cli/WaitCourse/WaitCourse";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import { Link } from "@/i18n/navigation";

const hasActiveTeam = (session) => {
    if (!session?.user) return false;

    if (
        session.user.currentTeam &&
        (session.user.currentTeam.teamStatus === "active" ||
            session.user.currentTeam.teamStatus === "trialing")
    ) {
        return true;
    }

    if (session.user.availableTeams?.length > 0) {
        return session.user.availableTeams.some(
            (team) =>
                team.teamStatus === "active" || team.teamStatus === "trialing",
        );
    }

    return false;
};

export default function CourseCTAActions({ course }) {
    const { data: session, status } = useSession();
    const t = useTranslations("CourseCTA");

    if (status === "loading") {
        return (
            <div className="h-[56px] animate-pulse rounded-xl bg-white/10" />
        );
    }

    const hasPremiumAccess = session?.user?.pro || hasActiveTeam(session);

    if (hasPremiumAccess) {
        return (
            <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.06] px-5 py-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-400">
                    <SolarIcon name="check-circle-bold" className="text-xl" />
                </span>
                <p className="mb-0 text-sm font-semibold text-white">
                    {t("course_cta_premium_access")}
                </p>
            </div>
        );
    }

    if (course.showWaitingMode) {
        return <WaitCourse course={course} stack />;
    }

    return (
        <div className="flex flex-col gap-3">
            <BuyCourse course={course} onDark />
            {/* Troisième action rétrogradée en lien : trois boutons empilés ne
                disaient plus lequel cliquer, et celui-ci n'est pas le chemin
                principal. La couleur est portée par le <span> et non par le
                <a>, sinon la règle globale a:hover le repeindrait en rose. */}
            <Link
                href="/pricing"
                className="group flex items-center justify-center gap-1.5 pt-1"
            >
                <span className="text-sm font-medium text-white/55 transition-colors group-hover:text-white">
                    {t("course_cta_teams")}
                </span>
                <SolarIcon
                    name="arrow-right-linear"
                    className="text-base text-white/55 transition-colors group-hover:text-white"
                />
            </Link>
        </div>
    );
}
